import { Param } from './util';

export type Setting = {
  id?: number;
  channel?: string;
  companyId?: number;
  deliveryZoneSettingParams?: Param[];
  workFlowSettingParams?: Param[];
};
